import * as React from "react";
import pageIds from "~/pageIds";
import type { CategorizedPageHelpRegistration, RenderRegistrationCardProps } from "../../../Registry/pageHelpRegistry";
import { CommonInfrastructureAccountOverview, CommonInfrastructureAccountTopics } from "../../CommonComponents/CommonInfrastructureAccountViews";
export const InfrastructureAccountsRegistration: CategorizedPageHelpRegistration = {
    page: pageIds.infrastructure.accounts.root,
    renderOverview: (renderProps: RenderRegistrationCardProps) => {
        return <CommonInfrastructureAccountOverview />;
    },
    renderTopics: (renderProps: RenderRegistrationCardProps) => {
        return <CommonInfrastructureAccountTopics />;
    },
};
